import { h } from 'preact'
import { useSignal } from '@preact/signals'
import { useEffect } from 'preact/hooks'

/**
 * LastSeen — shows "Online" or a human-readable time since last activity.
 *
 * Props: { personId, store }
 *
 * Reads store.presenceMap.value[personId] → { online, lastActiveAt }
 * Re-renders every 60 seconds to keep relative time accurate.
 */
export function LastSeen({ personId, store }) {
  if (!personId) return null

  // Tick every 60s to update relative time
  const tick = useSignal(0)
  useEffect(() => {
    const timer = setInterval(() => { tick.value += 1 }, 60_000)
    return () => clearInterval(timer)
  }, []) // eslint-disable-line

  const presence     = store.presenceMap.value[personId]
  const online       = presence?.online ?? false
  const lastActiveAt = presence?.lastActiveAt ?? presence?.last_active_at ?? null

  if (online) {
    return <span class="chat-last-seen chat-last-seen--online">Online</span>
  }

  if (!lastActiveAt) {
    return <span class="chat-last-seen chat-last-seen--offline">Nem elérhető</span>
  }

  return (
    <span class="chat-last-seen chat-last-seen--offline">
      {timeAgo(lastActiveAt)} volt online
    </span>
  )
}

/**
 * timeAgo — converts a datetime string to a short Hungarian relative label.
 * "Épp most" | "X perce" | "X órája" | "X napja"
 */
function timeAgo(dateStr) {
  if (!dateStr) return ''
  const now     = Date.now()
  const then    = new Date(dateStr).getTime()
  const diffSec = Math.max(0, Math.floor((now - then) / 1000))

  if (diffSec < 60)                          return 'Épp most'
  if (diffSec < 3600)  return `${Math.floor(diffSec / 60)} perce`
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)} órája`
  return `${Math.floor(diffSec / 86400)} napja`
}
